import React, {useRef, useState, useEffect} from 'react';
import { useDispatch } from 'react-redux'
import styles from './Products.module.css'
// import moment from 'moment'
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container'
import { Button } from '@material-ui/core';
import { useSnackbar } from 'react-simple-snackbar'
import {DataGrid, GridToolbar, GridCellEditStopReasons} from "@mui/x-data-grid";
import Alert from '@material-ui/lab/Alert';
import axios from 'axios';
import ProgressButton from 'react-progress-button'
import * as formData from 'form-data';
import { getProductsByUser } from '../../actions/productActions'

import { deleteProduct, updateProduct } from '../../actions/productActions';
import useAuthUser from '../../hooks/useAuthUser'
import { formatDollarsToCents, formatCentsToDollars, displayAsDollars } from '../../utils/money'
// import products from '../../products.json'

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),

  },
}));


const useStyles2 = makeStyles(theme => ({
  table: {
    minWidth: 500,
  },

  tablecell: {
    fontSize: '16px'
}
}));

const Products = ({ setOpen, setCurrentId, products, focusModel = "" }) => {

  // const sortedProducts = products.sort((a,b) => a.brand.toLowerCase().localeCompare(b.brand.toLowerCase()));
  const [openSnackbar, closeSnackbar] = useSnackbar()
  const [uploadStatus, setUploadStatus] = useState(null);
  const authData = useAuthUser()
  const dispatch = useDispatch()
  const typeArray = [...new Set(products.map(product => {
    if (product.type) {
      return product.type
    }
  }))]
  const inputRef = useRef(null);

  const handleUploadButtonClick = () => {
    inputRef.current.click();
  }

  const discontinueProduct = async (params) => {
    await new Promise((resolve, reject) => {
        resolve(dispatch(updateProduct(params.row._id, ({...params.row, discontinued: true}), openSnackbar)))
      }).then(() => {
        const userId = authData?.result?._id || authData?.result?.googleId
        if (userId) dispatch(getProductsByUser({ search: userId }));
      })
  }

  const handleFileChange = event => {
    const fileObj = event.target.files && event.target.files[0];
    if (!fileObj) {
      return;
    }
    if (!fileObj.name.toUpperCase().includes('MASTER_LIST')) {
      openSnackbar('Error: Please upload master_list');
      setUploadStatus('error')
      // 👇️ reset file input
      event.target.value = null;
      setTimeout(() => {
        setUploadStatus('')
      }, 3000)
    } else {
      const form = new formData();
      console.log(fileObj);
      form.append('csvFile', fileObj);

      setUploadStatus('loading')
      axios.post(`${process.env.REACT_APP_API}/upload-csv2`,
      form, {
        headers: {
          'Content-Type' : 'multipart/form-data'
        }
      })
      .then(res => {
        openSnackbar(res.data);
        setUploadStatus('success')
        const userId = authData?.result?._id || authData?.result?.googleId
        if (userId) dispatch(getProductsByUser({ search: userId }));
      })
    }
  };

  const processRowUpdate = React.useCallback(
    (newRow) => {
      // Make the HTTP request to save in the backend
      dispatch(updateProduct(newRow._id, newRow, openSnackbar))
      return newRow;
    }, []
  );

  const handleProcessRowUpdateError = React.useCallback((error) => {
    openSnackbar(error);
  }, []);
  
  // Create our number formatter.
  const normalizedFocus = React.useMemo(() => (focusModel || "").trim().toLowerCase(), [focusModel]);

  const { orderedProducts, highlightedRowId } = React.useMemo(() => {
    if (!normalizedFocus) return { orderedProducts: products, highlightedRowId: null };
    const matches = [];
    const rest = [];
    products.forEach(prod => {
      const model = (prod.modelNumber || "").toLowerCase();
      if (model.includes(normalizedFocus)) matches.push(prod);
      else rest.push(prod);
    });
    return {
      orderedProducts: [...matches, ...rest],
      highlightedRowId: matches[0]?._id || null,
    };
  }, [products, normalizedFocus]);
  
  const getRowClassName = (params) => {
    const cost = Number(params.row?.cost || 0);
    const price = Number(params.row?.price || 0);
    return price < cost ? 'row-loss' : '';
  };

const columns = [
  {
    field: 'modelNumber',
    headerName: 'Model Number',
    width: 150,
    editable: true,
  },
  { field: 'brand', headerName: 'Brand', width: 100, editable: true, },
  {
    field: 'cost',
    headerName: 'Cost',
    width: 150,
    editable: true,
    valueGetter: (params) => {
      if (!params.value) {
        return params.value;
      }
      const valueFormatted = displayAsDollars(params.value);
      return valueFormatted;
    },
    valueSetter: (params) => {
      let c = formatDollarsToCents(params.value)
      return { ...params.row,  cost: c};
    },
  },
  {
    field: 'price',
    headerName: 'Price',
    width: 150,
    editable: true,
    valueGetter: (params) => {
      if (!params.value) {
        return params.value;
      }
      const valueFormatted = displayAsDollars(params.value);
      return valueFormatted;
    },
    valueSetter: (params) => {
      let p = formatDollarsToCents(params.value)
      return { ...params.row,  price: p};
    },
  },
  {
    field: 'type',
    headerName: 'Type',
    width: 100,
    editable: true,
    type: 'singleSelect',
    valueOptions: typeArray
  },
  {
    field: 'description',
    headerName: 'Description',
    description: 'This column has a value getter and is not sortable.',
    sortable: false,
    editable: true,
    width: 300,
  },
  { field: 'actions', headerName: 'Actions', headerAlign: 'center', align: 'center', width: 250, renderCell: (params) => {
    return (
      <div style={{display: 'flex'}}>
        <Button
          style={{color: 'white', backgroundColor: 'rgb(25, 118, 210)', marginRight: 10}}
          onClick={() => discontinueProduct(params)}
          variant="contained"
        >
          Discontinue
        </Button>
        <Button
          style={{color: 'white', backgroundColor: 'red'}}
          onClick={() => dispatch(deleteProduct(params.row._id, openSnackbar))}
          
          variant="contained"
        >
          Delete
        </Button>
          

      </div>
      
    );
  } }
];


return (
  <div className={styles.pageLayout}>
    <Container style={{maxWidth: 1600}}>
      <div className={styles.buttons}>
      <h1 style={{paddingTop: 10}}>Products</h1>
        <button 
          // disabled={status === 'Paid' ? true : false}
          className={styles.btn} 
          onClick={() => setOpen((prev) => !prev)}> 
        Add Product
        </button>
          <input
            style={{display: 'none'}}
            ref={inputRef}
            type="file"
            accept=".csv"
            onChange={handleFileChange}
          />
          <ProgressButton 
            // disabled={status === 'Paid' ? true : false}
            style={{width: 150}}
            state={uploadStatus}
            onClick={handleUploadButtonClick}> 
          Upload CSV
          </ProgressButton>
      </div>
      <div className={styles.gridLayout}>
            <DataGrid
              autoHeight
              rows={orderedProducts}
              getRowId={(row) => row._id}
              getRowHeight={() => 'auto'}
              columns={columns}
              pageSize={20}
              getRowClassName={(params) => {
                const base = highlightedRowId && params.id === highlightedRowId ? styles.highlightRow : '';
                const loss = getRowClassName(params);
                return [base, loss && styles.rowLoss].filter(Boolean).join(' ');
              }}
              components={{
                Toolbar: GridToolbar,
              }}
              processRowUpdate={processRowUpdate}
              onProcessRowUpdateError={handleProcessRowUpdateError}
            />
        </div>
    </Container>
  </div>
  
);
}

export default Products
